import { render, staticRenderFns } from "./dolar.vue?vue&type=template&id=2ba29632&"
import script from "./dolar.vue?vue&type=script&lang=js&"
export * from "./dolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba29632')) {
      api.createRecord('2ba29632', component.options)
    } else {
      api.reload('2ba29632', component.options)
    }
    module.hot.accept("./dolar.vue?vue&type=template&id=2ba29632&", function () {
      api.rerender('2ba29632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/dolar.vue"
export default component.exports